import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgIcon } from '@ng-icons/core';
import { TranslatePipe } from '@ngx-translate/core';
import { LoadingService } from '../../../core/services/loading.service';

/**
 * Full-page busy overlay driven by `LoadingService`. Sits above modals (z-500) but below
 * toasts (z-600) so an error toast raised by the tracked work stays visible.
 */
@Component({
  selector: 'hntr-page-loader',
  imports: [NgIcon, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="sr-only" role="status" aria-live="polite">
      @if (loading.active()) {
        {{ 'common.loading' | translate }}
      }
    </div>
    @if (loading.active()) {
      <div
        class="fixed inset-0 z-550 flex flex-col items-center justify-center gap-3 bg-[rgba(26,38,57,0.45)] text-white cursor-wait"
        aria-hidden="true"
      >
        <ng-icon name="tablerLoader2" size="40" class="animate-spin" />
        <span class="text-[13px] font-bold">{{ 'common.loading' | translate }}</span>
      </div>
    }
  `,
})
export class PageLoader {
  protected readonly loading = inject(LoadingService);
}
